import { createFileRoute } from '@tanstack/react-router';
import { DispatchWizard } from '../../../features/sales-invoicing/DispatchWizard';

/** Owned by G23. Default tab of the sales-invoicing screen group — "Dispatch a
 * load" (BUILD_SPEC.md §8.4 steps 1-3), matching HOME_TASKS's task button which
 * routes straight to `/sales-invoicing`. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/')({
  component: DispatchWizard,
});
